import flatpickr from 'flatpickr';

/**
 * Value suitable for HTML datetime-local and `new Date()` in local TZ (no Z).
 */
export function dateToDatetimeLocalString(d) {
  if (!d || !(d instanceof Date) || Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function parseToDate(value) {
  if (value == null || value === '') return null;
  const d = new Date(String(value));
  return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * Defaults for admin “app-like” date+time pickers (calendar popup + readable alt field).
 */
export function adminDatetimePickerOptions(overrides = {}) {
  return {
    enableTime: true,
    time_24hr: true,
    altInput: true,
    altFormat: 'D, d M Y — H:i',
    minuteIncrement: 5,
    disableMobile: true,
    clickOpens: true,
    wrapClass: 'pdl-datetime-wrap',
    ...overrides,
  };
}

/** @param {HTMLInputElement | null} el */
export function mountAdminDatetime(el, opts = {}) {
  if (!el) return null;
  return flatpickr(el, adminDatetimePickerOptions(opts));
}
